var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './polyfills';
import "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../node_modules/slick-carousel/slick/slick.min.js";
import "../node_modules/smartbanner.js/dist/smartbanner.min.js";
if (environment.production ||
    process.env.NODE_ENV === 'production' ||
    process.env.NODE_ENV === 'ecd_eu' ||
    process.env.NODE_ENV === 'ecd_cg' ||
    process.env.NODE_ENV === 'ecd_mk') {
    enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
